const validTypes = ['image/webp', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/svg', 'image/png', 'image/gif'];

const validateImageType = (imageType: string): boolean => {
  return validTypes.some(acceptedType => acceptedType === imageType);
};

export default validateImageType;
